import { Segment } from '@/app/users/tracking/index.js'
import store from '@/store/store.js'

function callTrackIdentify() {
  /**
   * Checks if user analytics is enabled before proceeding.
   */
  if (!store.getters?.definitions?.enable_user_analytics) {
    return
  }

  /**
     * Constructs traits including the last page refresh time.
     */
  const traitsIncludingLastPageRefresh = {
    ...store.getters.segmentTraits,
    last_page_refresh: store.getters.lastPageRefresh,
  }

  Segment.identify(store.getters.user, traitsIncludingLastPageRefresh)
}

export default callTrackIdentify
